module.exports = __webpack_public_path__ + "static/media/popup-window.4883e6a6.png";